<script lang="ts">
  import type { SvelteHTMLElements } from 'svelte/elements'

  type Props = {
    color?: string
  } & SvelteHTMLElements['svg']

  let { color = 'currentColor', ...restProps }: Props = $props()
</script>

<svg viewBox="260 320 680 560" xmlns="http://www.w3.org/2000/svg" {...restProps}>
  <path
    d="m357.21 542.81c0 6.168-5 11.172-11.172 11.172-6.168 0-11.168-5.0039-11.172-11.172 0-6.1719 5-11.172 11.168-11.172 6.1719 0 11.172 5 11.172 11.172z"
    fill={color}
  />

  <path
    d="m382.61 542.81c0 6.168-5 11.172-11.172 11.172-6.168 0-11.172-5.0039-11.172-11.172 0-6.1719 5.0039-11.172 11.172-11.172 6.1719 0 11.172 5 11.172 11.172z"
    fill={color}
  />

  <path
    d="m408.25 542.81c0 6.168-5.0039 11.172-11.172 11.172-6.1719 0-11.172-5.0039-11.172-11.172 0-6.1719 5-11.172 11.172-11.172 6.168 0 11.172 5 11.172 11.172z"
    fill={color}
  />

  <path
    d="m357.09 661.63c0 6.1719-5.0039 11.172-11.172 11.172-6.1719 0-11.172-5-11.172-11.172 0-6.168 5-11.168 11.172-11.168 6.168 0 11.172 5 11.172 11.168z"
    fill={color}
  />

  <path
    d="m382.48 661.63c0 6.1719-5 11.172-11.168 11.172-6.1719 0-11.172-5-11.172-11.172 0-6.168 5-11.168 11.172-11.168 6.168 0 11.168 5 11.168 11.168z"
    fill={color}
  />

  <path
    d="m408.25 661.63c0 6.1719-5.0039 11.172-11.172 11.172-6.1719 0-11.172-5-11.172-11.172 0-6.168 5-11.168 11.172-11.168 6.168 0 11.172 5 11.172 11.168z"
    fill={color}
  />

  <path
    d="m355.31 784.27c0 6.168-5.0039 11.172-11.172 11.172-6.1719 0-11.172-5.0039-11.172-11.172 0-6.1719 5-11.172 11.172-11.172 6.168 0 11.172 5 11.172 11.172z"
    fill={color}
  />

  <path
    d="m380.83 784.27c0 6.168-5 11.172-11.172 11.172-6.168 0-11.172-5.0039-11.172-11.172 0-6.1719 5.0039-11.172 11.172-11.172 6.1719 0 11.172 5 11.172 11.172z"
    fill={color}
  />

  <path
    d="m406.47 784.27c0 6.168-5.0039 11.172-11.172 11.172-6.1719 0-11.172-5.0039-11.172-11.172 0-6.1719 5-11.172 11.172-11.172 6.168 0 11.172 5 11.172 11.172z"
    fill={color}
  />

  <path
    d="m355.31 431.99h53.699c7.3633 0 13.457-5.9648 13.457-13.457 0-7.3633-5.9648-13.457-13.457-13.457h-53.699c-7.3633 0-13.457 5.9648-13.457 13.457 0 7.4883 6.0938 13.457 13.457 13.457z"
    fill={color}
  />

  <path
    d="m458.39 431.99h118.44c7.3633 0 13.457-5.9648 13.457-13.457 0-7.3633-5.9648-13.457-13.457-13.457h-118.44c-7.3633 0-13.457 5.9648-13.457 13.457 0.003906 7.4883 5.9688 13.457 13.457 13.457z"
    fill={color}
  />

  <path
    d="m626.09 431.99h118.44c7.3633 0 13.457-5.9648 13.457-13.457 0-7.3633-5.9648-13.457-13.457-13.457h-118.44c-7.3633 0-13.457 5.9648-13.457 13.457 0 7.4883 5.9648 13.457 13.457 13.457z"
    fill={color}
  />

  <path
    d="m793.79 431.99h53.699c7.3633 0 13.457-5.9648 13.457-13.457 0-7.3633-5.9648-13.457-13.457-13.457h-53.699c-7.3633 0-13.457 5.9648-13.457 13.457 0 7.4883 5.9688 13.457 13.457 13.457z"
    fill={color}
  />

  <path
    d="m905.5 342.87h-609.6c-8.7578 0-15.742 7.1094-15.742 15.742v484.68c0 8.7578 7.1094 15.742 15.742 15.742h609.6c8.7578 0 15.742-7.1094 15.742-15.742v-484.68c0-8.7617-6.9844-15.742-15.742-15.742zm-11.172 26.914v95.715h-587.26v-95.715zm-153.86 122.63v94.32h-127.58v-94.32zm-154.5 94.449h-126.06v-94.32h126.06zm-153.1 0h-125.8v-94.32h125.8zm0 26.914v94.957l-125.8-0.003906v-94.957zm26.914 0h126.06v94.957h-126.06zm126.18 121.99v96.352h-126.06v-96.352zm26.914 0h127.58v96.352l-127.58 0.003906zm0-27.039v-94.957h127.58v94.957zm154.5-94.953h126.95v94.957h-126.95zm0-26.914v-94.32h126.95v94.32zm-460.31 148.91h125.8v96.352l-125.8 0.003906zm460.31 96.355v-96.352h126.95v96.352z"
    fill={color}
  />
</svg>
